export default {
  /* Main 頁面 */
  copyRight: 'Copyright',
  HomePage: '首頁',
  ProductArea: '產品領域',
  BrandConcept: '品牌理念',
  DevelopmentProcess: '開發流程',
  TechnicalSupport: '技術支援',
  contactus: '聯絡我們',
  copy: '複製',
  // footer
  phone: '+886.2.2556.2973',
  email: 'contact@wandatech.com.tw',
  add: '台北市大同區重慶北路一段30號3樓',
  /* Index 頁面 */
  more: '了解更多',
  // 介紹萬達區
  readMore: '了解更多',
  aboutTitle1: '關於',
  aboutTitle2: '萬達',
  aboutSubtitle: '願景與使命',
  aboutContent: '萬達資訊相信，通過持續的研究與開發，能夠製造出能夠與人類和諧共存，並在多種環境中提供幫助的機器人。萬達的目標是使AI機器人不僅是高科技的代名詞，更是可靠、安全、且具有社會責任感的同伴，並致力於打造一個更智慧、更連接、更好的未來。',
  cultureTitle: '文化與價值',
  cultureSubtitle1: '誠信',
  cultureSubtitle2: '團隊合作',
  cultureSubtitle3: '永不停止的創新',
  cultureContent1: '誠信是萬達資訊最核心的理念與價值。我們堅信以誠立業則無業不興，以誠信的態度對待股東、客戶、供貨商及員工，並與他們建立互信、互知、互助的關係，並精誠合作發展互享互惠。',
  cultureContent2: '人才是企業最重要的資產，具備即戰力的研發團隊，就是成功打造服務的重要關鍵。萬達資訊重視每一位元夥伴的專業成長與自我挑戰，培養出持續學習與成長的創新動能，並將溝通視為除了專業技能外最重要的工作能力，我們的團隊由跨越多種領域的夥伴共同組成，為具有遠大使命的企業客戶，供應長期的研發技術能量。',
  cultureContent3: '轉型需與時俱進而創新要落實在組織內。萬達資訊面對新時代 重新定義指標 隨時隨地尋找問題 改變習慣 以「多元創新環境，提升競爭優勢」理解內外部創新體質的重要性，經營全球, 放眼未來要有產品與技術實力，更需要敏銳的市場洞察力，方能永續。',
  // 開發過程區
  devMainTitle: '開發流程',
  devSubTitle1: '構思 & 設計',
  devSubTitle2: 'PoC & Prototype',
  devSubTitle3: '產品開發',
  devSubTitle4: '服務與規模',
  devSubContent1: '分析需求 藉專業的技術規劃出最適合的解決方案',
  devSubContent2: '驗證設計的開發概念 提高客戶需求的可行性',
  devSubContent3: '特定專案小組 獨立工作團隊 提高靈活性及即時交件率',
  devSubContent4: '同開發團隊進行維護及未來持續優化根據需求調整功能',
  // 技術支援區
  tectMainTitle: '技術支援',
  techIcon1: '技術支援',
  techIcon2: '教學指南',
  techIcon3: '用戶權益',

  /* Trade 頁面 */
  platformTitle: '隨時隨地 多平臺終端交易 ',
  platformSubTitle1: '覆蓋iOS、Android、Windows、Mac多個平臺，支持全業務功能。',
  platformSubTitle2: '',
  platIcon1: 'iOS, MAC',
  platIcon2: 'Android',
  platIcon3: 'Windows',
  platIcon4: '支援裝置',

  /* Wallet 頁面 */
  scopeTitle: '技術範圍',
  scopeSubtitle1: '加密藍牙連線',
  scopeSubtitle2: 'EAL 認證安全元件',
  scopeSubtitle3: '交易功能支援多種加密貨幣',
  scopeContent1: '適用於 Android 及 iOS 的加密藍牙連線，帶來最便利的行動加密貨幣使用體驗。',
  scopeContent2: '透過安全冷儲存技術，安心一覽投資組合與進行交易。',
  scopeContent3: '支援購買加密貨幣、Binance DEX、WalletConnect、代幣間交換及多種強化功能，有助加快對 DeFi 通訊協定、NFT 收藏品、DApps、及其他新興加密貨幣產品和服務的支援。',
  featureTitle: '產品特色 ',
  featureSubTitle1: '即時交換 ',
  featureSubTitle2: '簡易創建和導入錢包',
  featureSubTitle3: '輕鬆管理多鏈資產',
  featureSubTitle4: '保護您資產的最先進技術 ',
  featureSubTitle5: '安全存儲 ',
  featureContent1: '沒有表格，沒有自拍。隨時輕鬆交易加密貨幣。',
  featureContent2: '用戶友好的 UX 可幫助用戶輕鬆查看和訪問加密餘額。 ',
  featureContent3: '同時支持20種錢包類型，BTC、ETH、HECO、DOGE、XRP、DOT、KSM、BCH、LTC、ETC、TRX、 XTZ、EOS、ATOM、BCH等。',
  featureContent4: '用戶可以 100% 控制其安全存儲在您設備上的私鑰 。',
  featureContent5: '您的密鑰受到 Secure Enclave、生物識別身份驗證和可選的雲備份的保護。'
  // 置底用
}
